// API Configuration - supports both BFF and direct backend calls
export const USE_BFF = process.env.REACT_APP_USE_BFF === 'true' || false;

/** When true, all API calls route through the local API hub gateway (requires BFF). */
export const USE_API_HUB = process.env.REACT_APP_USE_API_HUB === 'true';

/**
 * API hub v2 (POST /apihub, api_token in header, no api_method).
 * false = legacy (PUT /apihub, api_token + api_method in body).
 */
export const API_HUB_V2 = process.env.REACT_APP_API_HUB_V2 === 'true';

/**
 * When true (and USE_API_HUB is true), calls /api/apihub directly instead of
 * POST /api/apicall. Token handling depends on REACT_APP_API_HUB_V2.
 */
export const USE_API_HUB_DIRECT = process.env.REACT_APP_API_HUB_DIRECT === 'true';

/** When true, direct API calls use the production FlowFuse host. */
export const USE_PROD = process.env.REACT_APP_PROD === 'true';

export const PROD_BASE_PATH =
  process.env.REACT_APP_PROD_BASE_PATH || 'https://nbrprod1.flowfuse.cloud';

export const DEV_BASE_PATH =
  process.env.REACT_APP_DEV_BASE_PATH ||
  process.env.REACT_APP_ORIGINAL_BASE_PATH ||
  'https://nbrdev1.flowfuse.cloud';

// Original backend API endpoint (dev by default; prod when REACT_APP_PROD=true)
export const ORIGINAL_BASE_PATH = USE_PROD ? PROD_BASE_PATH : DEV_BASE_PATH;

// Local BFF API endpoint - configurable via environment variable
export const BFF_BASE_PATH = process.env.REACT_APP_BFF_BASE_PATH || 'http://localhost:3001/api';

// Dynamic base path based on environment flag
export const BASE_PATH = USE_BFF ? BFF_BASE_PATH : ORIGINAL_BASE_PATH;

// Export individual paths for flexibility
export const getApiPath = (endpoint) => {
  return `${BASE_PATH}${endpoint}`;
};

// Helper to check if BFF is enabled
export const isBffEnabled = () => USE_BFF;

export const isApiHubEnabled = () => USE_API_HUB;

export const isApiHubDirectEnabled = () => USE_API_HUB && USE_API_HUB_DIRECT;

export const isApiHubV2 = () => API_HUB_V2;

export const isProd = () => USE_PROD;

// Same-origin gateway paths — resolve to the app's own host (localhost in dev, server URL in prod)
export const API_HUB_PATH =
  process.env.REACT_APP_API_HUB_PATH || '/api/apicall';

export const API_HUB_DIRECT_PATH =
  process.env.REACT_APP_API_HUB_DIRECT_PATH || '/api/apihub';

export const getApiHubGatewayPath = () =>
  isApiHubDirectEnabled() ? API_HUB_DIRECT_PATH : API_HUB_PATH;
